export default __webpack_public_path__ + "static/media/familyGenetics.0a8ae2e3.png";